if (!customElements.get('shop-the-look-updater')) {
  customElements.define(
    'shop-the-look-updater',
    class ShopTheLookUpdater extends HTMLElement {
      constructor() {
        super();
        this.abortController = undefined;
        this.variantChangeUnsubscriber = undefined;
      }

      connectedCallback() {
        this.contentEl = this.querySelector('.shop-the-look-updater__content');
        this.sectionWrapper = this.closest('.shopify-section');
        this.syncVisibility();

        if (typeof subscribe === 'function') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
        }
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
        this.abortController?.abort();
      }

      hasContent() {
        return Boolean(this.querySelector('.shop_the_look_section'));
      }

      syncVisibility() {
        const visible = this.hasContent();
        this.classList.toggle('shop-the-look-updater--empty', !visible);
        this.sectionWrapper?.classList.toggle('shop-the-look-section--hidden', !visible);
        this.toggleMediaBadge(visible);
      }

      onVariantChange({ data }) {
        const mainProduct = document.querySelector('.main_product_section');
        if (!mainProduct || mainProduct.dataset.productId !== this.dataset.productId) return;

        if (!data?.variant?.id) {
          this.replaceContent('');
          return;
        }

        this.fetchSection(data.variant.id);
      }

      fetchSection(variantId) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        const url = `${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.sectionId}`;

        fetch(url, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const fetchedUpdater = html.querySelector('shop-the-look-updater');
            const fetchedContent = fetchedUpdater?.querySelector('.shop-the-look-updater__content');
            this.replaceContent(fetchedContent ? fetchedContent.innerHTML : '');
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
            console.error(error);
          });
      }

      replaceContent(innerHTML) {
        if (!this.contentEl) return;

        this.contentEl.innerHTML = innerHTML;
        this.syncVisibility();
        this.resetSliders();
      }

      toggleMediaBadge(visible) {
        document.querySelectorAll('.product-media-badge').forEach((badge) => {
          badge.style.display = visible ? '' : 'none';
        });
      }

      resetSliders() {
        this.querySelectorAll('slider-component').forEach((slider) => {
          if (typeof slider.resetPages === 'function') {
            slider.resetPages();
          }
        });
      }
    }
  );
}
